var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var LinkableButton_1;
import { defaultOptions } from '@slickdeals/durango/dist/javascript/decorators/defaultOptions';
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import { doubleLinkable } from '../decorators/doubleLinkable';
import BlueprintComponent from '../core/blueprintComponent';
import Button from './button';
/** The name of the module */
export const name = 'LinkableButton';
/** The CSS selector for use in selector lookups in scripts */
export const JS_SELECTOR = 'js-linkableButton';
/** The base CSS classname for the main element controlled by this module */
export const CSS_CLASSNAME = 'bp-c-linkableButton';
let LinkableButton = LinkableButton_1 = class LinkableButton extends Button {
    constructor(options) {
        super(name, options);
    }
    async init() {
        this.element = await BlueprintComponent.loadElement(name, this.options);
        super.init();
        this.element.addEventListener('click', this.handleClick.bind(this));
    }
    handleClick() {
        this.activateDoubleLink();
    }
    getDoubleLinkableOptions() {
        return {
            foregroundUrl: this.getIsPopup() ? this.getHref2() : this.getHref(),
            backgroundUrl: this.getIsPopup() ? this.getHref() : this.getHref2(),
        };
    }
    getIsPopup() {
        return this.options.popup || this.element.dataset.popup;
    }
    getHref() {
        return this.options.href || this.element.dataset.href;
    }
    getHref2() {
        return this.options.href2 || this.element.dataset.href2;
    }
    static createElement(label = '', options) {
        const element = Button.createElement(label, options);
        element.classList.add(CSS_CLASSNAME);
        return element;
    }
    static createFromDataAttributes(element) {
        const options = {
            element,
            href: element.dataset.href ?? '',
            popup: (element.dataset.popup || false),
            href2: element.dataset.href2 ?? '',
        };
        return new LinkableButton_1(options);
    }
};
LinkableButton = LinkableButton_1 = __decorate([
    injectable(name),
    doubleLinkable(),
    defaultOptions({
        href: '',
        popup: false,
        href2: '',
    })
], LinkableButton);
BlueprintComponent.instantiate(name, {
    fromDom: true,
    fromMutation: true,
    fromHydrationQueue: false,
});
export default LinkableButton;
